import mixpanel from 'mixpanel-browser';


const token = 'c4f887f1a26a0298e90102c4020f7fc9';
mixpanel.init(token, {debug: true, track_pageview: true, persistence: 'localStorage'});

export default mixpanel;
